package com.nonopn.skywatcher.design.appbar

import androidx.compose.ui.graphics.vector.ImageVector

sealed class FloatingActionButtonState {
    data class Button(
        val label: String,
        val icon: ImageVector,
        val contentDescription: String,
        val action: () -> Unit,
    ) : FloatingActionButtonState()

    data class Menu(
        val icon: ImageVector,
        val contentDescription: String,
        val iconRotate: Float = 0f,
        val items: List<Button> = emptyList(),
    ) : FloatingActionButtonState()
}
